import {FunctionalComponent, h} from "preact";
import '../chat-viewport/background.scss';
import {
  buildImgURLFromAssetId,
  buildImgURLFromLegacyAssetId,
  preLoader
} from "../chat-msg-elements/media-box/MediaBoxService";
import {useEffect, useState} from "preact/hooks";
import {useRef} from "preact/compat";
import {CSSTransition, SwitchTransition} from 'react-transition-group'
import {log} from "../libs/QuerloLogger";

export const Background: FunctionalComponent<{ bkgData: any; assetsBaseURL: string }> = ({bkgData, assetsBaseURL}) => {

    const videosExts = ['ogv', 'ogg', 'mpg', 'mpeg', 'mp4', 'm4v', 'webm'];
    let isVideo = false;
    let type = '';
    let ext = '';
    // let bgFile: any;
    let isPexels = false;
    let metadata: any;
    
    const [background, setBackground] = useState<any>(null);
    const [loadableBgFile, setLoadableBgFile] = useState<string|null>(null);
    const [bgKey, setBgKey] = useState<string>('1');

    const activeLoadableBgFile = useRef<string>("");

    // log.info(`bkg component rendered, bkg data: ${JSON.stringify(bkgData)}`);

    const videoPlayer = useRef<HTMLVideoElement>(null);

    /** needed when changing video background multiple times to make it load new videos */
    useEffect(() => {
        // log.info(`use effect for ${msgText}`);
        if (type === 'video') {
            videoPlayer.current?.load();
        }
    }, [bkgData]);

    useEffect(() => {
      if (loadableBgFile) {
        /* in case multiple load background request arrive, and they don't finish in the same order as they arrived,
        we make sure we commit only the last scheduled one
         */
        activeLoadableBgFile.current = loadableBgFile;
        preLoader(loadableBgFile).then(
          () => {
            if (loadableBgFile !== activeLoadableBgFile.current) {
              log.info(`background preloader, discarding ${loadableBgFile} b/c we were waiting for '${activeLoadableBgFile.current}'`);
              return;
            }
            log.debug(`background preloader loaded '${loadableBgFile}'`);
            setBackground({ backgroundImage: `url(${loadableBgFile})` });
            setBgKey(loadableBgFile);
          },
          () => log.error(`background preloader failed to load: '${loadableBgFile}'`)
        );
      }
    }, [loadableBgFile]);


    function changeBg(newBg: string): void {
        for (let i = 0; i < videosExts.length; i++) {
            if (newBg.indexOf(videosExts[i]) > -1) isVideo = true;
        }

        if (!isVideo) {
            type = 'img';
            setLoadableBgFile(newBg);
            // setBackground({'background-image': `url(${  newBg  })`});
            setBgKey(newBg);
        } else {
            type = 'video';
            setBackground(newBg);
            setBgKey(newBg);
            // t.bgFile = 'https://querlo-assets-staging-cdn-endpoint.azureedge.net/image_uploads/cmdElementBkg/0_606de30448fbb_mp4.mp4';
        }
    }

    function changeBgFromMetadata(mtData: any): void {
        let tmpFile = '';
      switch (mtData.type) {
        case "hosted":
          tmpFile = buildImgURLFromAssetId(mtData.asset, assetsBaseURL, "image_uploads/cmdElementBkg/", mtData.mediaType === "video" ? "_hd" : "_bcgk");
          break;
        case "hosted-base-bkg":
          tmpFile = buildImgURLFromLegacyAssetId(mtData.asset, assetsBaseURL, "image_uploads/chatbkg/", "_bcgk");
          break;
        case "external":
        case "pexels":
        case "tenor":
          tmpFile = mtData.asset;
          if (mtData.type === "pexels") {
            isPexels = true;
            tmpFile = mtData.assetBig;
          }
          break;
      }

      // log.info(t.bgFile);
        if (mtData.mediaType === 'image') {
            type = 'img';
            setLoadableBgFile(tmpFile);
        } else if (mtData.mediaType === 'video') {
            type = 'video';
            setBackground(tmpFile);
          setBgKey(tmpFile);

          if (mtData.type === 'tenor') {
              const lastSegment = mtData.asset.split("/").pop();
              if (lastSegment.indexOf(".") === -1) {
                ext = lastSegment;
              } else {
                ext = lastSegment.split(".").pop();
              }
            } else if (mtData.type === 'external') {
                ext = mtData.asset.split('.').pop();
            } else if (mtData.type === 'hosted') {
                ext = mtData.asset.split('_').pop();
                if (mtData.status === 'encoding') {
                    setBackground('');
                    setBgKey(tmpFile);
                }
            }
        }
    }

    if (!bkgData) {
        return null;
    }

    if (typeof bkgData === 'object' && bkgData.metadata) {
        changeBgFromMetadata(bkgData.metadata);
    } else {
        changeBg(bkgData.path.indexOf('http') === -1 ? assetsBaseURL + bkgData.path : bkgData.path);
    }

     let content;

    if (type === 'img') {
        content = (<div key={bgKey} style={background} >
                    {isPexels && (<p className="imgCaption">
                        <a className="imgCredit" href="https://www.pexels.com" target="_blank" rel="noreferrer">
                            {metadata?.author ? metadata.author : ""} <img src="https://images.pexels.com/lib/api/pexels.png" />
                        </a>
                    </p>)}
                </div>);
    } else if (type === 'video') {
        content = (<video  key={bgKey}
                           onLoadedMetadata={(e): void => {(e.currentTarget as HTMLVideoElement).muted = true;}}
                           id="backgroundPlayer"
                           ref={videoPlayer}
                           muted
                           autoPlay
                           loop
                           playsInline>
            <source src={background} type={`video/${ext}`} />
        </video>);
    }

    return (type ? <div id="background">
        <SwitchTransition>
            <CSSTransition timeout={500}
                           key={bgKey}
                           classNames="fade">
                {content}
            </CSSTransition>
        </SwitchTransition>
      </div> : null);
/*
    return (
        <div>{JSON.stringify(bkgData)}</div>
    );*/
}
